import type { VisitorType } from '@/shared/types/store.types'
import { differenceInYears } from 'date-fns'

const AGE_RESTRICTION_THRESHOLD = 56
const UNDER_THRESHOLD_VISITORS_PER_SENIOR = 2

export const isYoungerThan23 = (birthDate: Date | string) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  const birth = new Date(birthDate)
  birth.setHours(0, 0, 0, 0)

  const date23YearsAgo = new Date(today.getFullYear() - 23, today.getMonth(), today.getDate())
  date23YearsAgo.setHours(0, 0, 0, 0)

  return birth > date23YearsAgo
}

export const lastFour = (passport: string) => passport.slice(-4)

export const formatHolderFullName = (visitor: { firstName: string; lastName: string }) =>
  `${visitor.firstName} ${visitor.lastName}`

export const collectHoldersPass = (visitors: VisitorType[]) =>
  visitors.map((v) => lastFour(v.passport))

export const isAgeRestrictionPassed = (visitors: Pick<VisitorType, 'birthDate'>[]) => {
  const today = new Date()
  const age56PlusCount = visitors.filter(
    (visitor) =>
      !!visitor.birthDate &&
      differenceInYears(today, visitor.birthDate) >= AGE_RESTRICTION_THRESHOLD
  ).length
  const under56Count = visitors.length - age56PlusCount

  return under56Count >= UNDER_THRESHOLD_VISITORS_PER_SENIOR * age56PlusCount
}
